import { ThemeProvider, ThemeToggle } from '@nrx/ui';
import type { JSX } from 'react';
import { Outlet } from 'react-router';

import { PortalAccountMenu } from './portal-account-menu.js';
import { PortalNav } from './portal-nav.js';

/**
 * Admin portal shell — sidebar + header (theme toggle + account menu) around nested routes.
 * Sign out lives in the account dropdown (AC #6).
 */
export function AdminPortalLayout(): JSX.Element {
  return (
    <ThemeProvider>
      <div className="flex min-h-screen max-md:flex-col">
        <aside className="flex w-[300px] max-w-full shrink-0 flex-col gap-4 border-r border-[var(--color-border)] bg-[var(--color-shell)] px-4 py-5 max-md:w-full max-md:border-r-0 max-md:border-b">
          <span className="text-lg font-semibold text-[var(--color-ink)]">NourishedRx</span>
          <PortalNav />
        </aside>
        <div className="flex min-w-0 flex-1 flex-col">
          <header className="flex items-center justify-end gap-2 border-b border-[var(--color-border)] bg-[var(--color-shell)] px-6 py-3">
            <ThemeToggle />
            <PortalAccountMenu />
          </header>
          <div className="min-w-0 flex-1 overflow-x-hidden py-6">
            <Outlet />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
